module.exports = __webpack_public_path__ + "img/Binoculars.1524039e.png";